(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from "react";
import useSubscribeHistory from "./useSubscribeHistory";

const SubscribeHistory = () => {
  useSubscribeHistory();
  return null;
};

__signature__(SubscribeHistory, "useSubscribeHistory{}", () => [useSubscribeHistory]);

SubscribeHistory.displayName = "SubscribeHistory";

const _default = /*#__PURE__*/React.memo(SubscribeHistory);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(SubscribeHistory, "SubscribeHistory", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/BrowserHistory/SubscribeHistory.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/BrowserHistory/SubscribeHistory.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();